import RequestForm from "@/pages/contact/RequestForm";
import { SUPPORT_FORM } from "@/pages/contact/requestFormsContent";

/**
 * `/support/request` (EN) and `/ar/support/request` (AR).
 *
 * The form contract / spam-protection / admin pipeline are identical to
 * the existing four request flows, so we just hand the existing
 * <RequestForm> component the new SUPPORT_FORM spec. The backend now
 * accepts `request_type: "support"` and persists submissions under the
 * "Support Requests" admin category.
 */
export default function SupportRequest() {
  return <RequestForm spec={SUPPORT_FORM} />;
}
